"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(-1072.683 -81.54)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(1072.683 81.54)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1084.682,105.537a12,12,0,1,1,12-12A12.013,12.013,0,0,1,1084.682,105.537Zm0-23.037a11.039,11.039,0,1,0,11.039,11.039A11.052,11.052,0,0,0,1084.682,82.5Z",
    transform: "translate(-1072.683 -81.54)"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#93c01f ",
    d: "M1087.951,92.837a.479.479,0,0,0-.679,0l-2.934,2.934-.622-.622a.48.48,0,0,0-.679.679l.962.961a.481.481,0,0,0,.679,0l3.273-3.273A.48.48,0,0,0,1087.951,92.837Z",
    transform: "translate(-0.41 -0.448)"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(1078.186 86.886)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#93c01f ",
    d: "M1084.912,101.9a.476.476,0,0,1-.167-.031c-5.853-2.167-6.329-6.52-6.329-11.568a.48.48,0,0,1,.355-.464c.043-.012,4.4-1.2,5.795-2.6a.509.509,0,0,1,.691,0c1.39,1.395,5.753,2.584,5.8,2.6a.48.48,0,0,1,.355.464c0,5.046-.476,9.4-6.329,11.568A.476.476,0,0,1,1084.912,101.9Zm-5.536-11.235c.021,4.774.526,8.315,5.536,10.242,5.009-1.927,5.514-5.469,5.535-10.242a19.255,19.255,0,0,1-5.535-2.446A19.283,19.283,0,0,1,1079.377,90.666Z",
    transform: "translate(-1078.416 -87.109)"
  }))));
};

exports["default"] = _default;